import classNames from 'classnames'
import { ButtonHTMLAttributes } from 'react'
import { Icon, IconName } from '../icon'
import styles from './index.module.css'

// The three-dot icon keeps its regular outline when selected; only its colour changes.
const keepsRegularWhenSelected: ReadonlySet<IconName> = new Set(['dots-three-vertical'])

const iconVariant = (icon: IconName, selected?: boolean) =>
  selected && !keepsRegularWhenSelected.has(icon) ? 'solid' : 'regular'

export type IconButtonSize = 'sm' | 'md'

export type IconButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & {
  icon: IconName
  // sm in cards and tables (borderless until hovered or selected), md directly on pages and in page headers.
  size?: IconButtonSize
  selected?: boolean
}

export const IconButton = ({ type = 'button', icon, size = 'md', selected, className, ...props }: IconButtonProps) => (
  <button
    type={type}
    aria-pressed={selected}
    {...props}
    className={classNames(styles.iconButton, styles[size], className)}
  >
    <Icon icon={icon} variant={iconVariant(icon, selected || props['aria-expanded'] === true)} />
  </button>
)
